function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var GoogleAds = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40",
  fill: "none"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M4.09885 26.6933L15.1655 7.7474C16.5713 8.57498 23.6597 12.498 24.8045 13.2439L13.7379 32.191C12.5276 33.79 2.56551 29.121 4.09885 26.6933Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/_jsx("path", {
    d: "M35.896 26.693L24.8293 7.74812C23.2823 5.1734 19.95 4.23777 17.2133 5.75847C14.4765 7.27915 13.6432 10.555 15.1903 13.2447L26.257 32.1918C27.8042 34.7653 31.1363 35.701 33.873 34.1803C36.4903 32.6597 37.4432 29.2677 35.896 26.6952V26.693Z",
    fill: "#4285F4"
  }), /*#__PURE__*/_jsx("path", {
    d: "M8.88854 34.9133C11.9566 34.9133 14.4437 32.4878 14.4437 29.496C14.4437 26.5042 11.9566 24.0788 8.88854 24.0788C5.82051 24.0788 3.33337 26.5042 3.33337 29.496C3.33337 32.4878 5.82051 34.9133 8.88854 34.9133Z",
    fill: "#34A853"
  })]
}));
GoogleAds.displayName = 'GoogleAds';
//# sourceMappingURL=GoogleAds.js.map